import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { PIC } from "@ryde/assets";
import { MuiButton } from "@ryde/controls";
import {
  PageHeaderContext,
  usePageContext,
  useTableFiltersActions,
} from "@ryde/redux";
import { tableFilteredGroupedCount, TDrawerCloseFunction } from "@ryde/shared";

import { MobilFiltersFooterStyled } from "./mobil-filters-footer.styled";

interface IMobilFiltersFooterProps {
  onCloseDrawer: TDrawerCloseFunction;
}

export const MobilFiltersFooter: FC<IMobilFiltersFooterProps> = ({
  onCloseDrawer,
}) => {
  const { entity } = usePageContext();
  const { t } = useTranslation();
  const rowsCount = useRecoilValue(tableFilteredGroupedCount(entity));

  const isDisabled = rowsCount < 1;

  const { handleClearFilters } = useTableFiltersActions();
  const { onFiltersClear } = useContext(PageHeaderContext);

  const onClear = async (): Promise<void> => {
    await handleClearFilters();
    onFiltersClear?.();
  };

  return (
    <MobilFiltersFooterStyled>
      <MuiButton disabled={isDisabled} onClick={onCloseDrawer}>
        {t("general.NO_RESULTS_FOUND", { results: rowsCount })}
      </MuiButton>
      <MuiButton
        muiVariant="text"
        muiStyle="error"
        startIcon={<PIC.FilterClearSvg />}
        onClick={onClear}
      >
        {t("general.CLEAR")}
      </MuiButton>
    </MobilFiltersFooterStyled>
  );
};
